import CustomButton from '../../../../../ui/CustomButton'
import { useContext, useEffect, useState } from 'react'
import { BusinessAPI } from '../../../../../../../api/business.api'
import GlobalContext from '../../../../../../../context/global-context'
import { BankAPI } from '../../../../../../../api/bancos.api'
import { Title } from '../../../../../ui'
import ResizableModal from '../../../../../ui/ResizableModal'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'

const InputField = ({ label, placeholder, type, value, onChange, disabled = false }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-sm font-sans
        ${disabled
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
          : 'focus:border-indigo-500 focus:ring-indigo-500'}
      `}
    />
  </div>
)

const TextAreaField = ({ label, value, onChange, ...props }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <textarea
      className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans'
      value={value}
      onChange={onChange}
      maxLength={50}
      required 
      {...props}
    />
    <p className="text-xs text-gray-500 mt-1 font-sans">
      {value.length}/50 caracteres
    </p>
  </div>
)

const ProvisionProveedor = ({ open, setOpen,type = 'egreso',setSwitchDate,idLibro,fVenc,folio,action}) => {
    const [movimientoSeleccionado] = useState(null)
    const [fecha, setFecha] = useState('')
    const [, setVencimiento] = useState("")
    const [glosa, setGlosa] = useState('')
    const [monto, setMonto] = useState('')
    const [rut, setRut] = useState('')
    const [tipoContrato, setTipoContrato] = useState("")
    const [razonSocial, setRazonSocial] = useState('')
    const businessAPI = new BusinessAPI()
    const organizationAPI = new OrganizationAPI()
    const { currentBusiness } = useContext(GlobalContext)
    const [data, setData] = useState({})
    const [, setDataBanco] = useState({})
    const bankAPI = new BankAPI()
    const [loading, setLoading] = useState(false)
    const [razonesS, setRazonesS] = useState({})
  
    const handleClose = () => setOpen(false)
  
    const getBanco = async () => {
        try {
          const responseBank = await bankAPI.getListBank(currentBusiness.id) 
          setDataBanco(responseBank)
        } catch (error) {
          console.error(error)
        }
      }
    
      useEffect(() => {
        getBanco()
      }, [currentBusiness])

    const functionGetData = async () => {
      try {
        setLoading(true)
        const response = await organizationAPI.getDataLibroContable(
          currentBusiness?.id, idLibro, type.trim()
        )
        setData(response.data)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }

  const getRazones = async () => {
    try {
      const response = await organizationAPI.getRazonSocial(currentBusiness?.id)
      setRazonesS(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      //
    }
  }

  useEffect(() => {
    if (open && idLibro) {
      functionGetData()
      getRazones()
    }
  }, [open, idLibro])

    useEffect(() => {
      if (data) {
        if (data.fecha) {
          const parsedDate = new Date(data.fecha)
          setFecha(parsedDate.toISOString().split('T')[0])
        }
        if (data.fechaVencimiento) {
          const parsedDate = new Date(data.fechaVencimiento)
          setVencimiento(parsedDate.toISOString().split('T')[0])
        }
        if (data.glosa) setGlosa(data.glosa)
        if (data.montoTotal) setMonto(data.montoTotal.toString())
        if (data.razonSocial) setRazonSocial(data.razonSocial)
        if (data.rut) setRut(data.rut)
        if (data.nombreCodigoDocumento) setTipoContrato(data.nombreCodigoDocumento)
      }
    }, [data])
    
    const handleDatos = async () => {
      if (!fecha || !monto || !rut || !razonSocial || !glosa) {
      alert("Todos los campos son obligatorios excepto folio")
      return
    }

      const payload = {
        fecha,
        transaccionId: action === "replicar" ? null : movimientoSeleccionado?.id,
        razonSocial,
        rut,
        rutId: null,
        nombreComprobante: tipoContrato || data.nombreCodigoDocumento, // aquí va el string del select
        nombreComprobanteId: null,
        glosa,
        respaldoId: null,
        monto: Number(monto),
      }
      try {
        setLoading(true)
        const response = await businessAPI.postPagoArriendo(currentBusiness.id, payload, 'devolucion-aporte-transitorio')
        console.info(response)
        setSwitchDate(true)
        handleClose()
      } catch (error) {
        console.error('Error al agregar comprobante:', error.message)
      } finally {
        setLoading(false)
      }
    }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const payload = {
        fecha,
        glosa,
        monto: Number(monto),
        razonSocial,
        rut,
        nombreComprobante: data.nombreCodigoDocumento,
      }

      const razonSeleccionada = razonesS?.find(r => r.rut === rut)
      const promises = []

      if (razonSeleccionada?.code) {
        const idRazonSocial = razonSeleccionada.code.split('-')[0]

        const payloadRazonSocial = { razonSocial } 
        promises.push(
          organizationAPI.patchRazonSocial(
            currentBusiness.id,
            idRazonSocial,
            payloadRazonSocial
          )
        )
      } else {
        //
      }

      promises.push(
        organizationAPI.updateVinculacion(
          currentBusiness?.id,
          idLibro,
          payload
        )
      )

      await Promise.all(promises)
      setSwitchDate(true)
      functionGetData()
      handleClose()

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

    const formatMonto = (value) => {
      if (!value) return '' 
      const numericValue = value.replace(/\D/g, '')
      if (!numericValue) return ''
      return new Intl.NumberFormat('es-CL').format(numericValue)
    }
    
    const formatRut = (input) => {
      let cleaned = input.replace(/[^0-9kK]/g, '').toUpperCase()
      // Limita a 9 caracteres (8 cuerpo + 1 DV)
      if (cleaned.length > 9) cleaned = cleaned.slice(0, 9)
      const body = cleaned.slice(0, -1)
      const dv = cleaned.slice(-1)
      let formattedBody = ''
      for (let i = body.length - 1, j = 1; i >= 0; i--, j++) {
        formattedBody = body[i] + formattedBody
        if (j % 3 === 0 && i !== 0) {
          formattedBody = '.' + formattedBody
        }
      }
      if (body.length === 0) return dv
      return `${formattedBody}-${dv}`
    }
  
    useEffect(() => {
      const today = new Date().toISOString().split("T")[0]
      setFecha(today)
      setVencimiento(today)
    }, [])
  
    return (
      <ResizableModal open={open} onClose={handleClose}
      footer={
        <>
          <CustomButton title='CANCELAR' color='primary' className='rounded-full' onClick={handleClose} />
          <CustomButton 
            title={
              action === 'replicar' ? 'REPLICAR VINCULACIÓN' : action === 'modificar'
                ? 'GRABAR VINCULACIÓN' : 'GRABAR VINCULACIÓN'
            }
            color='accent2'
            className='rounded-full'
            onClick={ action === 'modificar' ? handleSubmit : handleDatos }
          />
        </>
      }>
        <>
        {loading ?  (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie
              animationData={LoaderMain}
              loop
              autoplay
              style={{ width: 100, height: 100 }}
            />
          </Box>
          ) : (
            <>
            <div className="mt-4">
              <div className='flex justify-between items-center mb-6'>
                <div>
                  <Title className='text-3xl font-sans'>Provisión de fondo Proveedores</Title>
                </div>
              </div>
              <div className="flex w-full items-start h-full p-6 bg-white rounded-lg shadow-md'">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 w-full">
                  <InputField label="Folio" value={folio} type="text" disabled />
                  <div>
                    <label className="block text-sm font-sans font-medium text-gray-700">Fecha</label>
                    <input
                      type="date"
                      value={fecha}
                      onChange={(e) => setFecha(e.target.value)}
                      className="mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans"
                    />
                  </div>
                  <InputField
                    label="Contraparte"
                    placeholder="Contraparte"
                    type="text"
                    value={razonSocial}
                    onChange={(e) => setRazonSocial(e.target.value)}
                  />
                  <InputField
                    label="RUT"
                    placeholder="11.111.111-1"
                    type="text"
                    value={formatRut(rut)}
                    onChange={(e) => setRut(formatRut(e.target.value))}
                  />
                  <InputField
                    label="Monto Devuelto"
                    placeholder="$"
                    type="text"
                    value={formatMonto(monto)}
                    onChange={(e) => setMonto(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  <InputField label="Clasificación" placeholder="2-1-5-99 Aporte Transitorio Socio" type="text" disabled />
                  <TextAreaField
                    label="Detalle"
                    placeholder="Describe en detalle la naturaleza, origen o lo que mejor describa la vinculación que vamos a crear."
                    value={glosa}
                    onChange={(e) => setGlosa(e.target.value)}
                  />
                </div>
              </div>
            </div>
        </>
      )}
      </>
      </ResizableModal>
    )
}

export default ProvisionProveedor